// CELL-BIO9 — choice button rendering. 2–4 choices per node; unmet
// requirements are filtered out upstream in storyManager.
// Fires audio beep on selection.

import type { Choice } from "../engine/types";
import { audioEngine } from "../engine/audio";

export function renderChoices(
  root: HTMLElement,
  choices: Choice[],
  onPick: (choice: Choice) => void
): void {
  clearChoices(root);
  choices.forEach((choice, index) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = `choice ${choice.kind}`;
    btn.textContent = `[${index + 1}] ${choice.label}`;
    btn.addEventListener("click", () => {
      audioEngine.choiceBeep(index);
      onPick(choice);
    });
    root.appendChild(btn);
  });

  // Number-key shortcuts (1–4).
  const onKey = (ev: KeyboardEvent): void => {
    const n = Number(ev.key);
    if (!Number.isInteger(n) || n < 1 || n > choices.length) return;
    const choice = choices[n - 1];
    if (!choice) return;
    window.removeEventListener("keydown", onKey);
    audioEngine.choiceBeep(n - 1);
    onPick(choice);
  };
  window.addEventListener("keydown", onKey);
  root.dataset["keyBound"] = "1";
  // Store remover so clearChoices can unbind.
  keyHandlers.set(root, onKey);
}

const keyHandlers = new WeakMap<HTMLElement, (ev: KeyboardEvent) => void>();

export function clearChoices(root: HTMLElement): void {
  const handler = keyHandlers.get(root);
  if (handler) {
    window.removeEventListener("keydown", handler);
    keyHandlers.delete(root);
  }
  root.textContent = "";
}
